<zdb-avatar-initials  *ngIf="!base64Data; else avatar" [name]="name" [extraClass]="extraClass"></zdb-avatar-initials>
<ng-template #avatar>
    <div class="avatar" [ngClass]="extraClass"><img [src]="'data:' + contentType + ';base64,' + base64Data" [alt]="name" /></div>
</ng-template>
